import { Logement } from './generated/Logement';
import { LogementBase } from './LogementBase';
import { EtatAvancementProjet } from './EtatAvancementProjet';
import { Reservataire } from './Reservataire';
import { Financement } from './Financement';
import { Label } from './Label';
import { Caracteristique } from './Caracteristique';
import { Nature } from './Nature';
import { TypeLogement } from './TypeLogement';
import { Chauffages } from './Chauffages';
import { initDiagnosticFields } from './generated/logement/initDiagnosticFields';

function initLogementBase(bailleurId?: number, nomProgramme?: string): LogementBase {
  const now = new Date();
  return {
    id: 0,
    version: 0,
    creationDate: now,
    lastModificationDate: now,
    complet: false,
    comment: undefined,
    nomProgramme: nomProgramme,
    anneePC: undefined,
    anneeLivraison: undefined,
    anneeDesignation: undefined,
    rehabilitation: undefined,
    logementNeuf: undefined,
    etatAvancementProjet: EtatAvancementProjet.NonPrecise,
    suiviParArchitecte: undefined,
    numBatiment: undefined,
    numLogement: undefined,
    numRpls: undefined,
    reservataire: Reservataire.NonPrecise,
    financement: Financement.NonPrecise,
    adresse: undefined,
    complementAdresse: undefined,
    codePostal: undefined,
    arrondissement: 0,
    preconisationHanditoit: undefined,
    reglementationPMR: undefined,
    label: Label.NonPrecise,
    labelAutre: undefined,
    caracteristique: Caracteristique.NonPrecise,
    nature: Nature.NonPrecise,
    type: TypeLogement.NonPrecise,
    niveau: undefined,
    surface: undefined,
    chauffage: Chauffages.NonPrecise,
    jardin: false,
    balconOuTerrasse: false,
    loggia: false,
    garage: false,
    parking: false,
    prixParking: undefined,
    loyerHC: undefined,
    charges: undefined,
    commune: undefined,
    anneeRotation: undefined,
    bailleur: bailleurId,
    fiche: undefined,
    medias: [],
  };
}

export function initLogement(bailleurId?: number, nomProgramme?: string): Logement {
  return {
    ...initLogementBase(bailleurId, nomProgramme),
    ...initDiagnosticFields(),
  };
}
